module.exports = {
  title: '平台商品数据库',
  route: {
    path: '/platform-goods-manage',
    children: {
      path: 'platform-goods-database',
    },
  },
};
